import { useMemo } from 'react'
import { FiHelpCircle } from 'react-icons/fi'

import Panel from '~/components/Panel'
import Tooltip from '~/components/Tooltip'
import { Label } from '~/components/unform'
import { formatMoney } from '~/helpers'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

export default function StandardView({
  campaignData,
  Title
}: BudgetComponentProps) {
  const { t } = useAPPTranslation()

  const costValueIsValid = (value: string | number) =>
    value !== undefined && value !== null

  const dailyBudgetValue = campaignData?.settings?.daily_budget || null
  const cpmValue = campaignData?.settings?.cpm || null
  const dailyReproductionsValue = useMemo(
    () =>
      dailyBudgetValue && cpmValue
        ? Math.floor((Number(dailyBudgetValue) / Number(cpmValue)) * 1000)
        : null,
    [dailyBudgetValue, cpmValue]
  )

  return (
    <Panel
      data-investment-budget="standard-view"
      title={Title}
      description={t('rm:campaign.create.Investment.description')}
    >
      <section className="d-flex gap-3">
        {costValueIsValid(campaignData?.settings?.cpm) && (
          <div className="pe-3 border-end">
            <Label>
              {t('rm:dailyBudget')}
              <Tooltip
                icon={<FiHelpCircle />}
                text={t('rm:dailyBudget.tooltip')}
              />
            </Label>
            <span>{formatMoney(dailyBudgetValue)}</span>
          </div>
        )}
        {costValueIsValid(cpmValue) && (
          <div className="pe-3 border-end">
            <Label>
              {t('rm:cpm.title')}
              <Tooltip
                icon={<FiHelpCircle />}
                text={t('rm:metrics.cpm.tooltip')}
              />
            </Label>
            <span>{formatMoney(cpmValue)}</span>
          </div>
        )}
        {costValueIsValid(dailyReproductionsValue) && (
          <div>
            <Label>
              {t('rm:campaign.create.Investment.dailyReproductions.title')}
              <Tooltip
                icon={<FiHelpCircle />}
                text={t(
                  'rm:campaign.create.Investment.dailyReproductions.tooltip'
                )}
              />
            </Label>
            <span>{dailyReproductionsValue}</span>
          </div>
        )}
      </section>
    </Panel>
  )
}
